import { FolderPermissionLevel, FolderPermissionReadAccess, PermissionScope } from '../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../PermissionsDialogForm';

export function getPermissionLevelFromFormState(input: IPermissionsDialogForm): FolderPermissionLevel {
  switch (true) {
    case getIsLevelNone(input):
      return FolderPermissionLevel.NONE;
    case getIsLevelOwner(input):
      return FolderPermissionLevel.OWNER;
    case getIsLevelPublishingEditor(input):
      return FolderPermissionLevel.PUBLISHING_EDITOR;
    case getIsLevelEditor(input):
      return FolderPermissionLevel.EDITOR;
    case getIsLevelNonePublishingAuthor(input):
      return FolderPermissionLevel.PUBLISHING_AUTHOR;
    case getIsLevelNoneditingAuthor(input):
      return FolderPermissionLevel.NONEDITING_AUTHOR;
    case getIsLevelReviewer(input):
      return FolderPermissionLevel.REVIEWER;
    case getIsLevelContributor(input):
      return FolderPermissionLevel.CONTRIBUTOR;
    case getIsLevelAuthor(input):
      return FolderPermissionLevel.AUTHOR;
    case getIsLevelFreeBusyTimeOnly(input):
      return FolderPermissionLevel.FREE_BUSY_TIME_ONLY;
    case getIsLevelFreeBusyTimeAndSubjectAndLocation(input):
      return FolderPermissionLevel.FREE_BUSY_TIME_AND_SUBJECT_AND_LOCATION;
    default:
      return FolderPermissionLevel.CUSTOM;
  }
}

function getIsLevelNone(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.NONE &&
    input.deleteItems === PermissionScope.NONE &&
    input.canCreateItems === false &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === false
  );
}

function getIsLevelOwner(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.ALL &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === true &&
    input.editItems === PermissionScope.ALL &&
    input.isFolderOwner === true &&
    input.isFolderContact === true &&
    input.isFolderVisible === true
  );
}

function getIsLevelPublishingEditor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.ALL &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === true &&
    input.editItems === PermissionScope.ALL &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelEditor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.ALL &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.ALL &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelNonePublishingAuthor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.OWNED &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === true &&
    input.editItems === PermissionScope.OWNED &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelAuthor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.OWNED &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.OWNED &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelNoneditingAuthor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.OWNED &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelReviewer(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.FULL_DETAILS &&
    input.deleteItems === PermissionScope.NONE &&
    input.canCreateItems === false &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelContributor(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.NONE &&
    input.deleteItems === PermissionScope.NONE &&
    input.canCreateItems === true &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === true
  );
}

function getIsLevelFreeBusyTimeOnly(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.TIME_ONLY &&
    input.deleteItems === PermissionScope.NONE &&
    input.canCreateItems === false &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === false
  );
}

function getIsLevelFreeBusyTimeAndSubjectAndLocation(input: IPermissionsDialogForm): boolean {
  return (
    input.readItems === FolderPermissionReadAccess.TIME_AND_SUBJECT_AND_LOCATION &&
    input.deleteItems === PermissionScope.NONE &&
    input.canCreateItems === false &&
    input.canCreateSubfolders === false &&
    input.editItems === PermissionScope.NONE &&
    input.isFolderOwner === false &&
    input.isFolderContact === false &&
    input.isFolderVisible === false
  );
}
